export const config = {
  url:
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_GRAPH_URL
      : "http://localhost:8081/graphql",
  client_id: process.env.REACT_APP_ID,
  token_secret: process.env.REACT_APP_SECRET,
  redirect_uri:
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_REDIRECT_URL
      : "http://localhost:3000/&state=azerty"
};



// WEBPACK FOOTER //
// ./src/config.js